/* eslint-disable array-callback-return */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-nested-ternary */
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import useAuth from '../Hooks/useAuth';

const RequireAuth = ({ allowedRoles }) => {
  const { auth } = useAuth();
  const location = useLocation();

  return (
    auth?.verified === 0
      ? <Navigate to="/notverified" state={{ from: location }} replace />
      : allowedRoles?.map((role) => role === parseInt(auth.roles, 10)).find((val) => val === true)
        ? <Outlet />
        : auth?.accessToken
          ? <Navigate to="/unauthorized" state={{ from: location }} replace />
          : <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default RequireAuth;
